import React from "react";
import Sales from "../../components/assets/Sales";

const SalesManagementPage = () => {
  return (
    <>
      <Sales />
    </>
  );
};

export default SalesManagementPage;
